const blogs = [
    {
        slug: "haldi-sehat-aur-swad",
        title: "हल्दी: सेहत और स्वाद का खजाना",
        desc: "शुद्ध हल्दी कैसे आपकी सेहत, स्वाद और रोज़मर्रा की रसोई को बेहतर बनाती है।",
        image: "/images/blogs/1.jpg",
        date: "10 जनवरी 2026",
        content: `
हल्दी भारतीय रसोई का एक अनमोल मसाला है और सदियों से आयुर्वेद में इसका उपयोग किया जाता रहा है।

श्री बालाजी मसाले की हल्दी उच्च गुणवत्ता वाली, शुद्ध और प्राकृतिक कच्ची हल्दी से तैयार की जाती है,
जिससे इसका रंग, खुशबू और औषधीय गुण पूरी तरह सुरक्षित रहते हैं।

हल्दी में पाया जाने वाला करक्यूमिन शरीर की रोग प्रतिरोधक क्षमता को मजबूत करता है,
सूजन को कम करता है और पाचन को बेहतर बनाता है।

श्री बालाजी मसाले की शुद्ध हल्दी आपके भोजन को न सिर्फ स्वादिष्ट बनाती है,
बल्कि पूरे परिवार के स्वास्थ्य का भी ख्याल रखती है।
        `
    },
    {
        slug: "lal-mirch-kaise-chune",
        title: "सही लाल मिर्च कैसे चुनें?",
        desc: "असली और शुद्ध लाल मिर्च पाउडर पहचानने के आसान और सही तरीके।",
        image: "/images/blogs/2.jpg",
        date: "15 जनवरी 2026",
        content: `
लाल मिर्च किसी भी भारतीय व्यंजन का स्वाद और रंग बढ़ाने में अहम भूमिका निभाती है।

अच्छी गुणवत्ता वाली लाल मिर्च पाउडर का रंग गहरा, खुशबू तेज और तीखापन संतुलित होता है।
मिलावटी लाल मिर्च न सिर्फ स्वाद बिगाड़ती है, बल्कि स्वास्थ्य के लिए भी हानिकारक हो सकती है।

श्री बालाजी मसाले की लाल मिर्च सावधानीपूर्वक चुनी गई मिर्चों से बनाई जाती है
और आधुनिक स्वच्छ प्रक्रिया से तैयार की जाती है,
जिससे हर पैक में समान तीखापन और प्राकृतिक रंग बना रहता है।

हमारी लाल मिर्च हर सब्ज़ी और करी में असली स्वाद भर देती है।
        `
    },
    {
        slug: "garam-masala-ki-ahmiyat",
        title: "गरम मसाला: हर रेसिपी की जान",
        desc: "संतुलित गरम मसाला क्यों हर भारतीय रसोई में ज़रूरी है।",
        image: "/images/blogs/3.jpg",
        date: "20 जनवरी 2026",
        content: `
गरम मसाला कई चुनिंदा मसालों का संतुलित मिश्रण होता है,
जो खाने को खास खुशबू और गहराई देता है।

श्री बालाजी मसाले का गरम मसाला पारंपरिक विधि से तैयार किया जाता है,
जिसमें दालचीनी, इलायची, लौंग और अन्य मसालों का सही अनुपात रखा जाता है।

यह मसाला न सिर्फ स्वाद बढ़ाता है,
बल्कि पाचन में भी सहायक होता है।

एक चुटकी श्री बालाजी मसाले गरम मसाला
आपकी साधारण सब्ज़ी को भी खास बना देता है।
        `
    },
    {
        slug: "dhaniya-powder-ke-fayde",
        title: "धनिया पाउडर के फायदे",
        desc: "धनिया पाउडर कैसे स्वाद और सेहत दोनों के लिए लाभदायक है।",
        image: "/images/blogs/4.jpg",
        date: "25 जनवरी 2026",
        content: `
धनिया पाउडर भारतीय मसालों में सबसे ज़्यादा उपयोग किया जाने वाला मसाला है।

श्री बालाजी मसाले का धनिया पाउडर
ताज़े और सुगंधित धनिये से बनाया जाता है,
जिससे इसका स्वाद और खुशबू लंबे समय तक बनी रहती है।

धनिया पाचन को बेहतर करता है
और भोजन को हल्का व स्वादिष्ट बनाता है।

हमारा शुद्ध धनिया पाउडर
हर सब्ज़ी और दाल में संतुलित स्वाद लाता है।
        `
    },
    {
        slug: "masale-kaise-store-kare",
        title: "मसालों को सही तरीके से कैसे रखें?",
        desc: "मसालों की खुशबू और गुणवत्ता बनाए रखने के आसान घरेलू तरीके।",
        image: "/images/blogs/5.jpg",
        date: "28 जनवरी 2026",
        content: `
मसालों की ताज़गी बनाए रखने के लिए उनका सही तरीके से स्टोर करना बेहद ज़रूरी है।

मसालों को हमेशा एयरटाइट डिब्बों में रखें
और नमी व धूप से दूर रखें।

श्री बालाजी मसाले के पैक
इस तरह डिजाइन किए गए हैं
कि मसालों की खुशबू और गुणवत्ता लंबे समय तक सुरक्षित रहे।

सही स्टोरेज से मसालों का स्वाद बरकरार रहता है।
        `
    },
    {
        slug: "shuddh-masale-ki-pehchan",
        title: "शुद्ध मसालों की पहचान कैसे करें?",
        desc: "मिलावट और शुद्ध मसालों के बीच फर्क कैसे समझें।",
        image: "/images/blogs/6.jpg",
        date: "30 जनवरी 2026",
        content: `
आज के समय में शुद्ध मसालों की पहचान करना बहुत ज़रूरी हो गया है।

शुद्ध मसालों की खुशबू प्राकृतिक होती है,
रंग ज़्यादा चमकीला नहीं होता
और स्वाद संतुलित रहता है।

श्री बालाजी मसाले हमेशा
शुद्धता और गुणवत्ता को प्राथमिकता देता है
और हर पैक में भरोसेमंद स्वाद प्रदान करता है।

हमारा उद्देश्य है
हर घर तक शुद्ध और सुरक्षित मसाले पहुँचाना।
        `
    },
];

export default blogs;